export const DEFAULT_SORT = [
    {
        id: 'created_date',
        desc: true
    }
]

export const getSearchTableSelect = (t) => [
    {
        value: 'All',
        content: t('consultingAnalysis.list.searchAll') // 翻訳キーは適宜調整してください
    },
    {
        value: 'usage_or_client_folder',
        content: t('consultingAnalysis.list.usage_or_client_folder')
    },
    {
        value: 'theme_name',
        content: t('consultingAnalysis.list.theme_name')
    },
    {
        value: 'status',
        content: t('consultingAnalysis.list.status.title')
    },
    {
        value: 'user_name',
        content: t('consultingAnalysis.list.user_name')
    }
]
